module.exports = "1"



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/version.js
// module id = 26
// module chunks = 0